import { Button, Modal, ModalHeader, Typography } from "@joonapp/web-shared"
import { useMutation } from "@tanstack/react-query"
import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"

import DeleteAccount from "./DeleteAccount"
import useSettingsAccountModalStore from "./hooks/useSettingsAccountModalStore"
import PageLoader from "../../components/loading/PageLoader"
import { resetPassword } from "../../networking/authentication"
import { useUserQuery } from "../../networking/queries"

const SettingsAccountModal = () => {
  const { user } = useUserQuery()
  const { isOpen, onClose } = useSettingsAccountModalStore()
  const { t } = useTranslation()

  const { isLoading, mutate: resetPw } = useMutation({
    mutationFn: resetPassword,
    onSuccess: () => toast.success(t("SA_TOAST_RESET_SENT")),
    onError: () => toast.error(t("SA_TOAST_RESET_ERROR")),
  })

  if (!user || isLoading) return <PageLoader />

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      animate
      mobileFull
      style={{ width: "min(450px, 100vw)" }}
    >
      <ModalHeader title={t("SA_TITLE")} onClose={onClose} showBorderBottom />
      <div className="flex flex-col gap-2 p-6 pt-4 ">
        <Typography variant="bodySmallBold">{t("SA_MY_EMAIL")}</Typography>
        <Typography variant="h3">{user?.email}</Typography>
        <Button
          isLoading={isLoading}
          style={{ marginTop: "20px" }}
          disabled={isLoading}
          onClick={() => resetPw(user?.email)}
          text={t("SA_CHANGE_PASSWORD")}
          buttonType="secondary"
          size="small"
        />
        <DeleteAccount />
      </div>
    </Modal>
  )
}

export default SettingsAccountModal
